import React from "react";
import { useRouter } from "next/router";
import { JhButton } from "designPackages/buttonPackage";
import { Routes } from "routes/RouteConstants";
import LogService from "services/LogService";
import { WA_BROADCAST_EVENTS } from "utils/Events/waBroadCastEvents";

const ViewAllBroadcastsButton: React.FC = () => {
  const router = useRouter();

  const handleViewAllBroadCast = () => {
    LogService.log(WA_BROADCAST_EVENTS.WA_VIEW_ALL_BROADCAST_CLICK);
    router.push(Routes.VIEW_BROADCASTS);
  };

  return (
    <JhButton
      onClick={handleViewAllBroadCast}
      size="sm"
      variant="outline"
      className="hidden sm:block"
    >
      View All broadcasts
    </JhButton>
  );
};

export default ViewAllBroadcastsButton;
